<style lang="scss" type="text/scss">
  div {
    border-radius: 4px;
    background: #ff6452;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;

    box-shadow: -1px 0 30px -4px rgba(0, 0, 0, 0.15);
    margin: 30px 0 56px 0;
    padding: 8px 12px;

    transition: all 0.2s;

    svg {
      width: 20px;
      height: 20px;
      display: inline-block;
      fill: #fff;
      opacity: 0.8;
    }

    cursor: pointer;
  }

  .button:hover {
    background: #ef5442;
    text-decoration: none;
    box-shadow: -1px 0 30px -4px rgba(0, 0, 0, 0.25);
  }

  span {
    display: inline-block;
    margin-left: 8px;
    color: #fff;
    font-family: proxima-nova, sans-serif;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
  }

  span:hover {
    text-decoration: none;
  }
</style>

<script>
  export let label;
</script>

<div class="button">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path>
    <path d="M0 0h24v24H0z" fill="none"></path>
  </svg>
  <span>{label}</span>
</div>
